export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";